export function hasSubObjectSecurityLabel(securityLabel: string): boolean {
  const SUB_OBJECT_SECURITY = 'Dependent sub-object security policy variation';
  return SUB_OBJECT_SECURITY === securityLabel;
}
